import React from 'react';
import TransactionCommonModal from '../../common/TransactionCommonModal';
import FxCurrencyForm from './FxCurrencyForm';
import FxConfirmation from './FxConfirmation';
import PropTypes from 'prop-types';

const FxModal = ({
    formData,
    fieldError,
    setFormData,
    setFieldError,
    handleAmountChange,
    handleCurrencyChange,
    loadingRate,
    fxRate,
    fxFee,
    isConfirmModal,
    setIsConfirmModal,
    isLoading,
    isOpen,
    handleConfirmationModal,
    onClose,
    setSubmitError,
    submitError,
    submit,
    windowWidth,
}) => {
    const handleBack = () => {
        setIsConfirmModal(false);
        setSubmitError(null);
    };

    const handleExchange = async () => {
        if (typeof submit === 'function') {
            await submit();
        }
    };

    // Create a properly structured currencyFormProps object
    const currencyFormProps = {
        formData: {
            fromFiat: formData.fromFiatId,
            toFiat: formData.toFiatId,
            fromAmount: formData.fromFiatAmount,
            toAmount: formData.toFiatAmount,
        },
        fieldError,
        handleAmountChange,
        handleCurrencyChange,
        loadingRate,
        fxRate,
        setFormData,
        setFieldError,
        submitError,
    };

    return (
        <TransactionCommonModal
            open={isOpen}
            onClose={onClose}
            onBack={handleBack}
            heading={!isConfirmModal ? 'FX' : 'FX CONFIRMATION'}
            bottomButtonText={!isConfirmModal ? 'CONTINUE' : 'EXCHANGE'}
            onBottomButtonClick={!isConfirmModal ? handleConfirmationModal : handleExchange}
            showBackButton={isConfirmModal}
            showCloseIcon={true}
            disabled={
                !formData.fromFiatAmount ||
                !formData.toFiatAmount ||
                loadingRate ||
                [
                    fieldError.fromAmount ||
                        fieldError.toAmount ||
                        fieldError.toFiat ||
                        fieldError.fromFiat,
                ].some(Boolean)
            }
            error={submitError}
            loading={isLoading}
            loadingText={'PROCESSING'}>
            {!isConfirmModal ? (
                <FxCurrencyForm {...currencyFormProps} />
            ) : (
                <FxConfirmation formData={formData} fxFee={fxFee} fxRate={fxRate} />
            )}
        </TransactionCommonModal>
    );
};
FxModal.propTypes = {
    formData: PropTypes.object.isRequired,
    fieldError: PropTypes.object.isRequired,
    setFormData: PropTypes.func.isRequired,
    setFieldError: PropTypes.func.isRequired,
    handleAmountChange: PropTypes.func.isRequired,
    handleCurrencyChange: PropTypes.func.isRequired,
    loadingRate: PropTypes.bool.isRequired,
    fxRate: PropTypes.number,
    fxFee: PropTypes.number,
    isConfirmModal: PropTypes.bool.isRequired,
    setIsConfirmModal: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    isOpen: PropTypes.bool.isRequired,
    handleConfirmationModal: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    setSubmitError: PropTypes.func.isRequired,
    submitError: PropTypes.string,
    submit: PropTypes.func.isRequired,
};

export default FxModal;
